import { selector } from 'recoil';
import { agentUserId } from '../atoms/agentUserId';
import { buyPhoneNumber } from './buyPhoneNumber';
import { methodNameEnum, refetchToggle } from './makePHPRequest';
import {
  endpointEnum,
  makeAPIRequest,
} from '../../services/rest/makeAPIRequest';
export const getBusinessDids = selector({
  key: 'getBusinessDids',
  get: async ({ get }) => {
    try {
      const currentUser = get(agentUserId);
      get(refetchToggle(endpointEnum.GET_BUSINESS_DIDS));
      get(buyPhoneNumber);
      const final = [];
      // this is required here to subscribe to a change in addNewAgent atom-- this atom will only be changed on submititon of the add new agent form.
      // const url =
      //   `${process.env.VITE_APP_PHP_DOMAIN}/rest/functions.php?` +
      //   querystring.stringify({
      //     call: 'getBusinessDIDs',
      //     businessid: storageUser.businessid,
      //     apiKey: storageUser.apikey,
      //   });
      // const result = await axios.post(url, null, { withCredentials: true });
      const data = {
        call: methodNameEnum.GET_BUSINESS_DIDS,
      };
      const result = get(
        makeAPIRequest({
          endpoint: endpointEnum.GET_BUSINESS_DIDS,
          payloadJsonString: JSON.stringify(data),
        })
      );
      result?.response?.data?.result?.forEach((user) => {
        if (user?.entityid === +currentUser.id) {
          final?.push(user);
        }
      });
      return final;
    } catch (error) {
      throw error;
    }
  },
});
